import { IAddDynamicWidgetsConfig } from '../../core/types/AddDynamicWidgets';
import addComparisonChart from '../modules/addComparisonChart';
import { buildPlaceholders } from '../modules/buildPlaceholders';
import { UnbuiltPlaceholders } from '../modules/hawk/processWidgets/model';

export const addDynamicWidgets = async (
  config: IAddDynamicWidgetsConfig,
): Promise<HTMLElement[]> => {
  const {
    platformData: { articleType },
    site,
  } = config;
  const arrayOfUnbuiltPlaceholders: UnbuiltPlaceholders[] = [];

  if (articleType === 'deals_compare') {
    const selector = site.platform === 'progressive' ? '.blank' : undefined;
    const result = await addComparisonChart(selector);
    arrayOfUnbuiltPlaceholders.push(result);
  }

  return buildPlaceholders(arrayOfUnbuiltPlaceholders);
};
